import { AutocompleteItem } from '@prismamedia/one-components';
import { GetCategoriesQuery_query_categories_Category } from '__generated__/queries-web';

export const spreadCategoryChildren = (
  categories: GetCategoriesQuery_query_categories_Category[],
  parents: GetCategoriesQuery_query_categories_Category[],
  level = 0,
): AutocompleteItem[] =>
  parents.reduce(
    (prev, parentCategory) => [
      ...prev,
      {
        id: parentCategory.id,
        label: parentCategory.title,
        level,
      },
      ...spreadCategoryChildren(
        categories,
        categories.filter(({ parent }) => parent?.id === parentCategory.id),
        level + 1,
      ),
    ],
    [] as AutocompleteItem[],
  );
